import { render, staticRenderFns } from "./Webhooks.vue?vue&type=template&id=01eae53a"
import script from "./Webhooks.vue?vue&type=script&lang=js"
export * from "./Webhooks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports